import { vars, LinkButton, Text, Card, Stack, Inline, Heading } from '@etg/wings';
import { Icon } from '@eti/components';
import { useTranslation } from '@eti/providers';

const SelfTransferDealsNotification = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <Inline noWrap>
        <Inline aria-hidden>
          <Icon
            aria-hidden
            color={vars.colors.promotional.foreground}
            data-testid="self-transfer-icon"
            id="self-transfer"
            size="20px"
          />
        </Inline>
        <Stack spacing={4}>
          <Heading level={4}>{t('TravelerDetails.SelfTransferDeals.Card.Title')}</Heading>
          <Text>
            {t('TravelerDetails.SelfTransferDeals.Card.Description')}{' '}
            <LinkButton data-attributes="click focus" onClick={() => {}}>
              {t('TravelerDetails.SelfTransferDeals.Card.Link.Text')}
            </LinkButton>
          </Text>
        </Stack>
      </Inline>
    </Card>
  );
};

export default SelfTransferDealsNotification;
